import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'

export const Route = createFileRoute('/_app/payroll/runs')({
  staticData: { crumb: 'payrollRuns' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'payroll.read'),
  component: Outlet,
})
